import React from "react";
import { Route } from "react-router";
import OrderListPage from "pages/OrderPages/OrderListPage/OrderListPage";
import OrderDetailPage from "pages/OrderPages/OrderDetailPage/OrderDetailPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { UserNavigationGroup, UserRole } from "../types/declarations/enums.ts";

export const MyOrdersRoutes = ProtectedRoute({
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				path="projects"
				element={<OrderListPage />}
			/>
			<Route
				path="details/:orderId"
				element={<OrderDetailPage />}
			/>
		</>
	)
});
